/** Health “Device Heat Minutes by Bucket” bands (matches analytics-api health CASE). */

export type DeviceHeatBucketKey =
  | "<55"
  | "55-60"
  | "60-65"
  | "65-70"
  | "70-80"
  | "80-85"
  | "85+";

export type DeviceHeatBucketDef = {
  key: DeviceHeatBucketKey;
  /** Verbatim x-axis label (keep hyphens; do not pass through gameDisplayLabel). */
  label: string;
  /** Inclusive lower bound °C; omit for open lower end. */
  tempCelsiusMin?: number;
  /** Exclusive upper bound °C; omit for open upper end. */
  tempCelsiusMaxExclusive?: number;
  fill?: string;
};

export const DEVICE_HEAT_BUCKETS: readonly DeviceHeatBucketDef[] = [
  { key: "<55", label: "<55", tempCelsiusMaxExclusive: 55 },
  { key: "55-60", label: "55-60", tempCelsiusMin: 55, tempCelsiusMaxExclusive: 60 },
  { key: "60-65", label: "60-65", tempCelsiusMin: 60, tempCelsiusMaxExclusive: 65 },
  { key: "65-70", label: "65-70", tempCelsiusMin: 65, tempCelsiusMaxExclusive: 70 },
  { key: "70-80", label: "70-80", tempCelsiusMin: 70, tempCelsiusMaxExclusive: 80 },
  {
    key: "80-85",
    label: "80-85",
    tempCelsiusMin: 80,
    tempCelsiusMaxExclusive: 85,
    fill: "var(--color-warn)",
  },
  { key: "85+", label: "85+", tempCelsiusMin: 85, fill: "var(--color-err)" },
] as const;

export const DEVICE_HEAT_BUCKET_ORDER: DeviceHeatBucketKey[] = DEVICE_HEAT_BUCKETS.map(
  (b) => b.key,
);
